import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Dialog, Classes, Switch } from '@blueprintjs/core'
import { refreshSolution } from 'src/store/modules/runbooks/actions'
import {
    singleEditAction,
    toggleControl,
} from 'src/store/modules/ui/runbook/controls'

class RefreshCmdbDialog extends React.Component {
    state = {
        ascending: true,
        selectedAvZones: [],
    }
    handleAscChange = () => this.setState({ ascending: !this.state.ascending })
    handleClose = () => {
        this.props.actions.singleEditAction(null)
        this.props.actions.toggleControl('isRefreshingCmdb')
    }
    handleClick = () => {
        this.props.actions.refreshSolution(this.props.singleOpenAction, {
            ascending: this.state.ascending,
            avZones: this.state.selectedAvZones,
        })
        this.handleClose()
    }
    render() {
        const { ascending } = this.state
        return (
            <Dialog
                isOpen={true}
                title="Refresh action from CMDB"
                onClose={this.handleClose}
            >
                <div className={Classes.DIALOG_BODY}>
                    <Switch
                        label="Ascending"
                        checked={ascending}
                        onChange={this.handleAscChange}
                        className={Classes.FIXED}
                    />
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <Button large intent="primary" onClick={this.handleClick}>
                        Confirm
                    </Button>
                    <Button
                        large
                        intent="lynch-underline"
                        onClick={this.handleClose}
                    >
                        Close
                    </Button>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => ({
    singleOpenAction: state.ui.runbook.controls.singleOpenAction,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    actions: bindActionCreators(
        {
            refreshSolution: (id, params) =>
                refreshSolution(ownProps.runbookId, id, params),
            singleEditAction,
            toggleControl,
        },
        dispatch
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(RefreshCmdbDialog)
